import axios from "../axios";

export const inventoryIntegrationApi = {
  status: () => axios.get("/inventory/integration_status"),
  sync: () => axios.post("/inventory/integration_sync"),
  conflicts: (params = {}) => axios.get("/inventory/integration_conflicts", { params }),
  conflict: (id) => axios.get(`/inventory/integration_conflicts/${id}`),
  resolve: (id, payload) => axios.post(`/inventory/integration_conflicts/${id}/resolve`, payload),
  updateSettings: (mode) => axios.patch("/inventory/integration_settings", { mode }),
};
